module.exports = "footer {\r\n  background-color: #9a9a9a;\r\n  line-height: 14px;\r\n  text-align: left;\r\n  clear: both;\r\n}\r\nfooter a{\r\ncolor: #fff;\r\n}\r\nfooter .nav-link:focus, .nav-link:hover{\r\n    text-decoration: underline;\r\n  }\r\n@media (min-width: 576px) {\r\n    footer {\r\n    bottom: 0;\r\n    /* position: absolute; */\r\n}\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/opc/footer/footer.component.css
// module id = ./src/opc/footer/footer.component.css
// module chunks = main